import { styled } from "@mui/material";

const PORTRAIT_STACK_QUERY =
	"(max-width: 720px), ((max-width: 755px) and (orientation: portrait))";
const MOBILE_TAGS_QUERY = "(max-width: 720px)";

export const Layer = styled("div")`
	position: fixed;
	right: 0;
	bottom: 25px;
	left: 0;
	z-index: 999;
	pointer-events: none;

	@media ${PORTRAIT_STACK_QUERY} {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
	}
`;

export const TagsStack = styled("div")`
	position: absolute;
	bottom: 0;
	left: 50%;
	display: flex;
	width: max-content;
	max-width: calc(100vw - 256px);
	flex-direction: column;
	align-items: center;
	transform: translateX(-50%);
	pointer-events: none;
	gap: 12px;

	&:empty {
		display: none;
	}

	& > * {
		max-width: 100%;
	}

	@media ${PORTRAIT_STACK_QUERY} {
		position: static;
		order: 2;
		width: 100%;
		max-width: none;
		align-items: center;
		transform: none;
	}

	@media ${MOBILE_TAGS_QUERY} {
		align-items: flex-start;
	}
`;

export const IconStack = styled("div")`
	position: absolute;
	bottom: 0;
	left: 18px;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	pointer-events: none;

	&:empty {
		display: none;
	}

	& > * {
		pointer-events: auto;
	}

	@media ${PORTRAIT_STACK_QUERY} {
		position: static;
		order: 1;
		margin-left: 18px;
	}
`;
